import React from "react";
import "./index.scss";
import {strings} from "../../../../strings/strings";
import {SendContractToEmailForm} from "../../SendContractToEmailForm";
import {TravelQuotation} from "../../../../model/quotation";
import {ProductType} from "../../../../api/model/common";


interface TravelCardSuccessfulQuotationViewProps {
    quotation: TravelQuotation
}

export const TravelCardSuccessfulQuotationView = ({quotation}: TravelCardSuccessfulQuotationViewProps) =>
    <div  className="successful-quotation__content__left__info">
        <h1>{strings.congrats}</h1>
        <p>{strings.successfullQuotationTravel}</p>
        <p>
            {strings.successfulQuotation1}
            <span className={"accent"}>{quotation?.travelWebContract.primaryInsured.email}</span>
            {strings.successfulQuotation2}
        </p>
        <SendContractToEmailForm quotationId={quotation.id} type={ProductType.TRAVEL}/>
    </div>
